import Bills from './Bills'

export default Bills
